function Footer() {
  return (
    <>
      <div className="contact">Send Me Email: <a style={{textDecoration: "none"}} href="mailto:niloufar.moradijam@gmail.com">niloufar.moradijam@gmail.com</a></div>
    </>
  );
}

export default Footer;
